// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"313":"0fec3258","484":"40ac4083","605":"0fec3258","741":"0fec3258"}[chunkId] + ".chunk.css";
};